import(/* webpackMode: "eager" */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(app)/events/create/page.tsx");
